import { Controller } from '@hotwired/stimulus';
import $ from 'jquery';
import { validateTextArea, onPasteSanitize } from '../../js/summernote_utils';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [
        'submitButton',
        'descriptionTextarea',
    ];

    initialState = {};

    connect() {
        const placeholderText = this.descriptionTextareaTarget.getAttribute('placeholder') || '';

        $(this.descriptionTextareaTarget).summernote({
            toolbar: [
                ['style', ['bold', 'italic']],
                ['para', ['ul', 'ol']],
                ['toggleEditor'],
            ],
            tooltip: false,
            disableResizeEditor: true,
            placeholder: placeholderText,
            callbacks: {
                onInit: () => {
                    const content = $(this.descriptionTextareaTarget).summernote('code').trim();

                    if (content === '') {
                        $('.note-placeholder').show();
                    }
                },
                onFocus: () => {
                    $('.note-placeholder').hide();
                },
                onPaste: onPasteSanitize,
            },

        });
    }

    async save() {
        this.submitButtonTarget.disabled = true;
        showPreloader();
        const values = [];

        $('[name="recruitmentType[]"]').each((index, value) => {
            if ($(value).is(':checked')) {
                values.push($(value).attr('id'));
            }
        });

        const data = {
            field: 'recruitment',
            value: JSON.stringify(values),
        };

        try {
            const responseProfileEditRecruitment = await fetch(routes['app_profile_edit'], {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: new URLSearchParams(data),
            }).then(
                responseProfileEditRecruitment => responseProfileEditRecruitment.json(),
            );

            if (responseProfileEditRecruitment.status) {
                const cleanedDescription = validateTextArea($(this.descriptionTextareaTarget).parent().find('.note-editable'));

                const data = {
                    field: 'recruitment_description',
                    value: cleanedDescription,
                };

                const responseProfileEditRecruitmentDescription = await fetch(routes['app_profile_edit'], {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    body: new URLSearchParams(data),
                }).then(
                    responseProfileEditRecruitmentDescription => responseProfileEditRecruitmentDescription.json(),
                );

                if (responseProfileEditRecruitmentDescription.status) {
                    dataLayer.push({
                        event: 'dataLayer.gaEvent',
                        gaEvent: {
                            'category': 'Account',
                            'action': 'profile_recruitment_update',
                            'label': '',
                        },
                    });

                    window.location.reload();
                } else {
                    addAlert('danger', responseProfileEditRecruitmentDescription.message || translations['profile.An unknown error occurred.']);
                    this.submitButtonTarget.disabled = false;
                    hidePreloader();
                }
                return;
            } else {
                addAlert('danger', translations['profile.An unknown error occurred.']);
            }
        } catch (error) {
            addAlert('danger', translations['profile.An unknown error occurred.']);
        }

        this.submitButtonTarget.disabled = false;
        hidePreloader();
    }

    async recruitmentTypeChanged() {
        const values = [];

        $('[name="recruitmentType[]"]').each((index, value) => {
            if ($(value).is(':checked')) {
                values.push($(value).attr('id'));
            }
        });

        const data = {
            field: 'recruitment',
            value: JSON.stringify(values),
        };

        try {
            const response = await fetch(routes['app_profile_edit'], {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: new URLSearchParams(data),
            });

            const json = await response.json();

            if (!response.ok || !json.status) {
                addAlert('danger', json.message || translations['profile.An unknown error occurred.']);
            }
        } catch (error) {
            addAlert('danger', translations['profile.An unknown error occurred.']);
        }
    }
}
